<template lang="pug">
#map-wrapper
  map(:center.sync='center', :map-type-id.sync='terrain', :zoom.sync='20')
    marker(:position.sync="marker", :clickable.sync="false", :draggable.sync="false", @g-click="marker")
h2.company-name {{'COMPANY_NAME' | wordDict}}
section
  .container
    .row
      .contact-info.col-sm-6
        h4 {{'HEADQUARTERS' | wordDict}}
        p {{{'COMPANY_LOCATION' | wordDict | markdown }}}

        h4 {{'GENERAL_ENQUIRY' | wordDict}}
        p {{{'GENERAL_CONTACT_MD' | wordDict | markdown}}}

        h4 {{'MEDIA_ENQUIRY' | wordDict}}
        p {{{'MEDIA_CONTACT_MD' | wordDict | markdown}}}
      .col-xs-12.visible-xs
        hr.mobile-hr
      .col-sm-6
        form#enquiry-form.form-horizontal('@submit.prevent'="sendEnquiry")
          .form-group
            label.col-sm-2.control-label(for="enquiry-name") {{'LABEL_NAME' | wordDict}}
            .col-sm-10
              input#enquiry-name.form-control(type="text" v-model="enquiry.name" name="name" required)

          .form-group
            label.col-sm-2.control-label(for="enquiry-email") {{'LABEL_EMAIL' | wordDict}}
            .col-sm-10
              input#enquiry-email.form-control(type="email" v-model="enquiry.email" name="email" required )

          .form-group
            label.col-sm-2.control-label(for="enquiry-category") {{'LABEL_CATEGORY' | wordDict}}
            .col-sm-10
              select#enquiry-category.form-control(v-model="enquiry.category" name="category")
                option(val="Media" selected) Media
                option(val="Pitch" ) Pitch
                option(val="Jobs" ) Jobs
                option(val="Business Development" ) Business Development
                option(val="Others" ) Others

          .form-group
            label.col-sm-2.control-label(for="enquiry-subject") {{'LABEL_SUBJECT' | wordDict}}
            .col-sm-10
              input#enquiry-subject.form-control(type="text" v-model="enquiry.subject" required)

          .form-group
            label.col-sm-2.control-label(for="enquiry-message") {{'LABEL_MESSAGE' | wordDict}}
            .col-sm-10
              textarea#enquiry-message.form-control(v-model="enquiry.message" rows="5" required)

          .form-group
            .col-sm-10.col-sm-push-2
              .row
                .col-sm-6
                  .col-xs-6.col-sm-12.upload-button
                    input#fileUpload(type='file', hidden, @change='fileChosen')
                    button.full-width.btn(@click.prevent='chooseFiles()')
                      span.caption {{'UPLOAD_DOC' | wordDict}}
                  .col-xs-6.col-sm-12
                    br
                    | {{'UPLOAD_DOC_LIMIT' | wordDict}}
                .col-sm-6
                  button.full-width.btn.btn-black(':disabled'="!valid")
                    span.caption {{'SEND' | wordDict}}
//- script(src="https://maps.googleapis.com/maps/api/js?key=AIzaSyBKyo3qbHcn6lQSRdYILZHqxXAZ49t8v0I&amp;" async defer)
</template>

<script>
import axios from 'axios'
import {load, Map, Marker} from 'vue-google-maps'
load('AIzaSyBKyo3qbHcn6lQSRdYILZHqxXAZ49t8v0I')
export default {
  data () {
    return {
      valid: false,
      enquiry: {
        name: '',
        email: '',
        subject: '',
        message: '',
      },
      file: null,
      center: {lat: 22.2804971, lng: 114.1573817},
      marker: {lat: 22.2804971, lng: 114.1573817},
    }
  },
  computed: {
  },
  ready () {
    // const map = new google.maps.Map(document.getElementById('map'), {
    //   center: posiiton,
    //   zoom: 17,
    // });
    //
    // new google.maps.Marker({
    //   map: map,
    //   position: posiiton,
    // });
  },
  watch: {
    'enquiry.name'() { this.checkFormValid() },
    'enquiry.email'() { this.checkFormValid() },
    'enquiry.subject'() { this.checkFormValid() },
    'enquiry.message'() { this.checkFormValid() },
  },
  attached () {},
  methods: {
    fileChosen(e) {
      let files = e.target.files || e.dataTransfer.files
      if (!files.length || !files[0])
        return
      if (files[0].size >= 5242800) { //5mb
        alert(window.wordDict.UPLOAD_DOC_EXCEEDED)
        return
      }
      this.file = files[0]
    },
    chooseFiles() {
      document.getElementById('fileUpload').click();
    },
    sendEnquiry(e) {
      let promise = null
      if (this.file) {
        let fd = new FormData()
        fd.append('file', this.file)
        promise = axios.post('/api/resources/files', fd, {
          headers: {'Content-Type': 'multipart/form-data'}
        })
      } else {
        promise = Promise.resolve({})
      }
      promise.then((res) => {
        if (res && res.status < 400) {
          this.enquiry.attachment = res.data
        }
        return axios.post('/api/enquiry', this.enquiry)
      }).then((res) => {
        if (res.status < 400) {
          alert(window.wordDict.ENQUIRY_SUCCESS)
          this.enquiry = {}
          this.file = null
        } else {
          alert(window.wordDict.ENQUIRY_FAILED)
        }
      }).catch((err) => {
        alert(window.wordDict.ENQUIRY_FAILED)
      })
    },
    checkFormValid() {
      this.valid = _.every(this.enquiry, val => val)
    }
  },
  components: {
    Map,
    Marker
  }
}
</script>

<style lang="scss" scoped>
@import "global";

button > span.caption {
  width: 100%;
  margin: 0;
  text-align: center;
  line-height: initial;
}
@media(max-width: #{$screen-xs-max}) {
  h2 {
    font-size: 18px;
  }
  .container {
    margin: 0;
  }
}
.company-name {
  font-weight: bold;
  text-transform: uppercase;
  text-align: center;
  margin-top: 60px;
  @media(max-width: #{$screen-xs-max}) {
    margin-top: 28px;
  }
}
#map-wrapper {
  height: 500px;
  @media(max-width: #{$screen-xs-max}) {
    height: 166px;
  }
}
.btn-black {
  background-color: #000;
  color: #FFF;
  &:hover {
    color: #FFF;
  }
}
.full-width {
  width: 100%;
}
.form-control {
  background-color: #f6f6f6;
  border: none;
  box-shadow: none;
}
.control-label {
  text-align: left;
  @media(min-width: #{$screen-sm-min}) {
    padding-left: 5px;
  }
}
hr.mobile-hr {
  padding-bottom: 15px;
}
.contact-info {
  h4 {
    text-transform: uppercase;
    font-weight: bold;
  }

  h5 {
    margin-bottom: 0;
  }

  p {
    margin-top: 20px;
    margin-bottom: 40px;
    @media(max-width: #{$screen-xs-max}) {
      margin-bottom: 20px;
    }
  }
  @media(max-width: #{$screen-xs-max}) {
    h4 {
      font-size: 14px;
    }
    text-align: center;
  }
}

section {
  padding-top: 30px;
  padding-bottom: 30px;
  &:last-child {
    padding-bottom: 30px;
  }
  @media(max-width: #{$screen-xs-max}) {
    padding-top: 12px;
    padding-bottom: 12px;
    &#content {
      padding-bottom: 6px;
    }
    &:last-child {
      padding-bottom: 0;
    }
  }
}
.upload-button {
  padding: 0;
  .btn {
    font-size: 13px;
    background-color: #f6f6f6;
    padding: 7px 0px;
  }
  @media(max-width: #{$screen-xs-max}) {
    padding-bottom: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// contact-page.vue?ae777e3a